(() => {
  const notice = document.querySelector('[data-flaay-cart-notice]');
  if (!notice) return;
  const image = notice.querySelector('[data-notice-image]');
  let timer;
  const hide = () => { clearTimeout(timer); notice.hidden = true; };
  const position = () => {
    const header = document.querySelector('header-component') || document.querySelector('#header-group');
    const bottom = header?.getBoundingClientRect().bottom || 0;
    notice.style.setProperty('--flaay-notice-top', `${Math.max(0, Math.min(bottom, window.innerHeight - 80))}px`);
  };
  document.addEventListener('flaay:cart-added', (event) => {
    const item = event.detail?.items?.[0] || event.detail;
    if (!item || item.status) return;
    const src = item.featured_image?.url || item.image;
    image.hidden = true;
    image.removeAttribute('src');
    if (typeof src === 'string' && src) { image.src = src; image.hidden = false; }
    position();
    notice.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(hide, 4500);
  });
  image.addEventListener('error', () => { image.hidden = true; });
  notice.querySelector('[data-notice-close]').addEventListener('click', hide);
  window.addEventListener('scroll', () => { if (!notice.hidden) position(); }, {passive:true});
  window.addEventListener('resize', () => { if (!notice.hidden) position(); });
  window.addEventListener('pageshow', (event) => { if (event.persisted) hide(); });
})();
